export enum Blockchain {
  BAHAMUT = 'Bahamut',
  ETHEREUM = 'Ethereum'
}

export enum ReviewStatus {
  Pending = 'pending',
  Rejected = 'rejected',
  Approved = 'approved'
}

export enum Wallets {
  METAMASK = 'Metamask',
  COINBASE = 'Coinbase'
}
